angular.module( 'acme.view.application.account.configuration', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.account.configuration.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var accountConfiguration = {
        name: 'application.account.configuration',
        url: '/configuration',
        views: {
          "subview-main": {
            controller: 'AccountConfigurationController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/account/configuration/configuration.tpl.html'
          }
        },
        data: {
          pageTitle: 'Configuration',
          /** Secure With Permissions **/
          permissions: ['CONF_VIEW', 'CONF_GLCODE_VIEW']
        }
      };

    $stateProvider
      .state(accountConfiguration);
});
